<template>
  <div class="box-style-breadcrumb card flex justify-content-center">
        <Breadcrumb :model="items" :home="home" />
  </div>
</template>

<script>



export default {
  props: {
    //OBJECT
    items: Array,
  },
  data() {
    return {
      home: {
        label: ' Home',
        icon: 'pi pi-home',
        to: '/admin/list-dashboard',
        // command: () => {
        //   if (this.$router.currentRoute.path !== '/admin/list-dashboard') {
        //     this.navigateToHome();
        //   }
        // },
      },
    }
  },
  created() {
    // console.log("this.contentSetthis.contentSet",this.contentSet);
   // this.formData.content = this.contentSet;
  },
  watch: {
   

  },
  // watch: {
  //   '$route': 'initParams'
  // },
  methods: {
    navigateToHome() {
      // Điều hướng đến trang chủ
      //this.$router.push('/admin/list-dashboard');
      window.location.href = '/admin/list-dashboard';
    },
  },
}
</script>
<style lang="scss">
.box-style-breadcrumb{
  border: unset!important;;
  border-radius: unset!important;
  padding: 0px!important;
  box-shadow: unset!important;
  .p-breadcrumb{
    border: unset!important;
    border-radius: unset!important;
    padding: 0px!important;
    background: unset!important;
  }
}
</style>